import React, { useState, useEffect, useRef, useCallback } from 'react';
import { SearchIconGray, UserVerifiedBadge, ClearSearchIcon } from 'components/Icons';
import API from '../../API';
import verifiedIcon from '../../images/authorised.svg';
import notFoundIcon from '../../images/not-found.svg';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/Loader'
import {VerifiedIcon} from '../../components/Icons'
import Avatar from 'components/Avatar';
const Search = () => {
  const [searchValue, setSearchValue] = useState('');
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFound, setIsFound] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [page, setPage] = useState(0);
  const history = useHistory();
  const { t } = useTranslation();

  const handleSearch = query => {
    setSearchValue(query);
    setIsFound(false);
    setResponse([])
    setPage(0)
  };

  useEffect(() => {
   if (!searchValue.trim()) return;

   const typingIdentifier = setTimeout (() =>{
      if(lastPage === page) return;

      setLoading(true);
      API.post(`profiles/search`, {page: page + 1, query: searchValue })
        .then((resp) => {
          setResponse([...response, ...resp.data])
          setIsFound(true)
          setLastPage(resp.meta.last_page)
        })
        .finally(() => setLoading(false))
    }, 400)
    return () => clearTimeout(typingIdentifier)
  }, [page, searchValue]);
  
  const observer = useRef();

  const lastPostElementRef = React.useCallback(
    node => {
      if (loading || lastPage === page) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(post => {
        if (post[0].isIntersecting) {
					setPage(page + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading]
  ); 

  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className="search-input-header">
          <input
            type="text"
            placeholder={t("search_comedians")}
            value={searchValue}
            onChange={evt => {
              handleSearch(evt.target.value);
              // setSearchValue(evt.target.value);
            }}
          />

          {!searchValue ? <SearchIconGray /> : <ClearSearchIcon onClick={() => setSearchValue('')} />}
        </div>
      </div>
      <div style={{ marginTop: '24px' }}>
        {searchValue && response.length ? (
          response.map((person, index) => {
            return (
              <div key={index} className="search-result-box" onClick={ () =>  history.push(`/u/${person.user.id}`)}   ref={response.length === index + 1 ? lastPostElementRef : null}>
              
                <div className="left-info-container">
                <Avatar className='search-user-avatar' size={48} image={person.user.avatar}/>
                  <div className="search-user-container">
                    <div className="d-flex align-items-center">
                      <h1 className="search-user-name">{person.user.name}</h1>
                      {person.user.verification_status === "verified" && <VerifiedIcon height="1rem" width="1rem" className="fill-white search-page-verivication" />}
                    </div>
                    {/* <p className="search-user-role">Artist</p> */}
                    <p className="search-user-role" style={{ paddingTop: 5 }}>
                      {t(`Subscribed by artist name`)}
                    </p>
                  </div>
                </div>
                <div className="subscribe-button-wrapper">
                  <button className="discard-button">{person.following ? t(`Subscribed`) : t(`Subscribe`)} </button>
                </div>
              </div>
            );
          })
        ) : 
        response.length === 0 && isFound && searchValue ? (
        <div>
            <div className="not-found-image">
              <img alt="not-found" src={notFoundIcon} />
            </div>
            <p className="not-found-text">{t("nothing_found")}</p>
          </div>
        ) : null}
      </div>
      <Loader className="channels-loader" isLoadin={loading}></Loader>     
    </div>
  );
};

export default Search;
